import {useRef, useEffect, useMemo} from 'react';
import {Props} from './model';
import View from './view';

export const Text = (props: Props) => {
  const {title, ...rest} = props; // ToDo: we need common HOC for title

  const ref = useRef<HTMLElement>();
  const viewProps = useMemo(() => ({ref, ...rest}), [rest, ref]);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    if (!title && !ref.current.title) {
      return;
    }

    ref.current.title = title || '';
  }, [ref.current, title]);

  return View(viewProps);
};
